var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center flex-column",on:{"click":_vm.handler}},[_c('div',{staticClass:"circle"},[_c('img',{staticClass:"plus-icon",attrs:{"src":require(`@/assets/icons/${_vm.icon}.svg`)}})]),_c('span',{staticClass:"textCircle"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }